import React, { useState } from "react";
import MonthlyStatisticsTable from "./Components/MonthlyStatisticsTable";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const today = new Date();

const MonthlyStatistics = () => {
    const [filters, setFilters] = useState({
        month: today.getMonth() + 1,
        year: today.getFullYear(),
    });

    const handleChange = (e) => {
        const { value } = e.target;

        // value comes as "2026-07"
        if (!value) return;

        const [year, month] = value.split("-");

        setFilters({
            month: Number(month),
            year: Number(year),
        });
    };


    return (
        <PageBody
            card
            headerchildren={
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 w-100">
                    <HeadingOne>
                        Monthly Statistics Report
                    </HeadingOne>
                </div>
            }
        >
            <div className="col-12">
                <MonthlyStatisticsTable
                    filters={filters}
                    date={{
                        key: "month-year",
                        field: {
                            name: "month_year",
                            required: false,
                            fieldSize: "p-0",
                            placeholder: "Select Month",
                            lableHide: true,
                        },
                        value: `${filters.year}-${String(filters.month).padStart(2, "0")}`,
                        handleChange,
                        error: "",
                        mode: "monthYear",
                        selectMode: "single",
                    }}
                />
            </div>
        </PageBody>
    );
};

export default MonthlyStatistics;